export enum STATUS {
  NEW = 'N',
  COMPLETE = 'C',
  DELETED = 'D'
}

export enum FILE_TYPE {
  VIDEO = 'video',
  AUDIO = 'audio',
  PICTURES = 'pictures',
  DOCUMENTS = 'documents',
  OTHER = 'other'
}

export enum EventType {
  PLUVIOMETER_MONITORING = 'PLUVIOMETER_MONITORING',
  TRAP_MONITORING = 'TRAP_MONITORING',
  SCOUTING_MONITORING = 'SCOUTING_MONITORING',
  ANNOTATION = 'ANNOTATION',
  MONITORING = 'MONITORING',
  STATIC_POINT = 'STATIC_POINT',
  PLUVIOMETER = 'PLUVIOMETER',
  TRAP = 'TRAP',
  GENERIC = 'GENERIC',
  PHENOLOGY = 'PHENOLOGY',
  APPLICATION = 'APPLICATION',
  NONE = 'NONE',
  HARVESTING = 'HARVESTING',
  IRRIGATION = 'IRRIGATION',
  PLANTING = 'PLANTING',
  DETASSELING = 'DETASSELING',
  EMERGENCE = 'EMERGENCE',
  ROGUING = 'ROGUING',
  FLOWERING = 'FLOWERING',
  MALE_DESTRUCTION = 'MALE_DESTRUCTION',
  FLAMING = 'FLAMING',
  CUSTOM_FORM = 'CUSTOM_FORM'
}
